<template>
    <button
        type="button"
        class="a-close-button close-button"
        :aria-label="ariaLabel"
        @click="onClick"
    >
        <svg-icon
            original
            name="icons/close-circle"
            class="close-button__icon"
        />
    </button>
</template>

<script>
export default {
    name: 'AMItemsCloseButton',
    props: {
        ariaLabel: {
            type: String,
            default: 'Close button'
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-close-button";
</style>